const hubSpotTracking = {
  identifyUser (email, id) {
    if (window.hsTracker) {
      window.hsTracker.identify({
        email,
        id,
      });
    }
  },
  trackPageView () {
    if (window.hsTracker) {
      window.hsTracker.trackPageView(window.location.pathname);
    }
  },
};

export default hubSpotTracking;
